import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { publicApi } from '../services/api'
import type { Event } from '../types'
import LoadingSpinner from '../components/common/LoadingSpinner'

export default function EventList() {
  const [events, setEvents] = useState<Event[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    async function fetchEvents() {
      try {
        const response = await publicApi.getEvents()
        setEvents(response.events)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load events')
      } finally {
        setLoading(false)
      }
    }

    fetchEvents()
  }, [])

  if (loading) {
    return (
      <div className="py-12">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (error) {
    return (
      <div className="card text-center py-12">
        <p className="text-red-600 mb-4">{error}</p>
        <button
          onClick={() => window.location.reload()}
          className="btn btn-primary"
        >
          Try Again
        </button>
      </div>
    )
  }

  if (events.length === 0) {
    return (
      <div className="card text-center py-12">
        <h2 className="text-2xl font-bold text-gray-700 mb-2">
          No Active Events
        </h2>
        <p className="text-gray-500">
          Check back later for upcoming fundraising events.
        </p>
      </div>
    )
  }

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-800 mb-6">
        Upcoming Events
      </h1>

      <div className="grid gap-6">
        {events.map((event) => (
          <div key={event.eventId} className="card hover:shadow-lg transition-shadow">
            <h2 className="text-2xl font-bold text-sla-blue mb-2">
              {event.name}
            </h2>
            <p className="text-gray-600 mb-4">{event.description}</p>
            <div className="flex flex-wrap gap-3">
              <Link
                to={`/e/${event.slug}`}
                className="btn btn-primary"
              >
                Register Now
              </Link>
              <Link
                to={`/s/${event.slug}`}
                className="btn btn-secondary"
              >
                Sponsorship Sign Up
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
